import {IComponentOptions} from 'angular';
import IAttributes = angular.IAttributes;
declare let require: any;
declare let angular: any;
require('./dv-error-messages.scss');
let errTemplate = require('./dv-error-messages.html');

export class DvErrorMessagesComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        requiredText: '@',
        errorObject: '<for'
    };
    template = errTemplate;
    controller = DvErrorMessages;
    controllerAs = 'vm';
}

export class DvErrorMessages {
    static $inject: string[] = ['$attrs'];
    isOpaque: boolean;
    requiredText: string;

    constructor(private $attrs: IAttributes) {
    }

    $onInit() {
        this.isOpaque = 'opaque' in this.$attrs;
        if (this.requiredText === undefined) {
            this.requiredText = 'ERROR_REQUIRED';  //default required key
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-error-messages/dv-error-messages.ts